import type { InputState } from '@/shared/types';
import type { TouchControls } from './touch-controls';

const KEY_BINDINGS: Record<string, keyof InputState> = {
  ArrowLeft: 'left',
  KeyA: 'left',
  ArrowRight: 'right',
  KeyD: 'right',
  ArrowUp: 'up',
  KeyW: 'up',
  ArrowDown: 'down',
  KeyS: 'down',
  KeyJ: 'attack1',
  KeyK: 'attack2',
  KeyL: 'special',
  ShiftLeft: 'block',
  ShiftRight: 'block',
};

export class InputHandler {
  private keyState: InputState = {
    left: false,
    right: false,
    up: false,
    down: false,
    attack1: false,
    attack2: false,
    special: false,
    block: false,
  };

  private touchControls: TouchControls | null = null;

  constructor() {
    window.addEventListener('keydown', (e) => this.onKey(e.code, true));
    window.addEventListener('keyup', (e) => this.onKey(e.code, false));
  }

  setTouchControls(tc: TouchControls): void {
    this.touchControls = tc;
  }

  private onKey(code: string, pressed: boolean): void {
    const action = KEY_BINDINGS[code];
    if (action) {
      this.keyState[action] = pressed;
    }
  }

  getState(): InputState {
    const kb = this.keyState;

    if (this.touchControls?.isVisible()) {
      const tc = this.touchControls.getState();
      return {
        left: kb.left || tc.left,
        right: kb.right || tc.right,
        up: kb.up || tc.up,
        down: kb.down || tc.down,
        attack1: kb.attack1 || tc.attack1,
        attack2: kb.attack2 || tc.attack2,
        special: kb.special || tc.special,
        block: kb.block || tc.block,
      };
    }

    return { ...kb };
  }

  consumeAttacks(): { attack1: boolean; attack2: boolean; special: boolean } {
    const kbAttacks = {
      attack1: this.keyState.attack1,
      attack2: this.keyState.attack2,
      special: this.keyState.special,
    };
    this.keyState.attack1 = false;
    this.keyState.attack2 = false;
    this.keyState.special = false;

    if (this.touchControls?.isVisible()) {
      const tcAttacks = this.touchControls.consumeAttacks();
      return {
        attack1: kbAttacks.attack1 || tcAttacks.attack1,
        attack2: kbAttacks.attack2 || tcAttacks.attack2,
        special: kbAttacks.special || tcAttacks.special,
      };
    }

    return kbAttacks;
  }
}
